<button
  #button
  mat-icon-button
  type="button"
  [matBadge]="translator?.input?.value | translationLength"
  [matBadgeHidden]="countHidden"
  [attr.aria-haspopup]="translator ? 'dialog' : null"
  [attr.aria-label]="ariaLabel"
  [attr.tabindex]="disabled ? -1 : tabIndex"
  [disabled]="disabled"
  (click)="open($event)"
>
  <mat-icon>translate</mat-icon>
</button>
